import { Model } from '@vuex-orm/core'
import Checkout from '@/models/user/Checkout'

export default class SpecialWish extends Model {
  declare checkoutId: string
  declare specialWish?: Checkout
  declare lateArrival: boolean
  declare dailyNewspaper: boolean
  declare allergicBedLinen: boolean
  declare bathrobes: boolean
  declare message?: string

  static entity = 'SpecialWishes'
  static primaryKey = 'checkoutId'

  static fields() {
    return {
      checkoutId: this.uid(),
      specialWish: this.belongsTo(Checkout, 'checkoutId'),
      lateArrival: this.attr(null),
      dailyNewspaper: this.boolean(false),
      allergicBedLinen: this.boolean(false),
      bathrobes: this.boolean(false),
      message: this.attr(null).nullable()
    }
  }
}
